import { MaterialService } from './../../service/material.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from './../../service/authentification.service';
import { FormControl, Validators } from '@angular/forms';
import { Component, OnInit, HostListener, OnDestroy } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { Subject, takeUntil } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { advancedEmailValidator } from '../../validators/email.validators';

export enum KEY_CODE {
  RIGHT_ARROW = 39,
  LEFT_ARROW = 37,
  ENTER_KEY = 13
}

@Component({
  selector: 'app-lost-password',
  templateUrl: './lost-password.component.html',
  styleUrls: ['./lost-password.component.scss', '../login/login.ux.scss']
})
export class LostPasswordComponent implements OnInit, OnDestroy {
  emailFormControl = new FormControl('', [
    Validators.required,
    advancedEmailValidator()
  ]);
  site: string;

  private _unsubscribeAll: Subject<any> = new Subject<any>();
  loading = false;

  constructor(
    private authenticationService: AuthenticationService,
    private route: ActivatedRoute,
    private router: Router,
    private materialService: MaterialService,
    private translateService: TranslateService
  ) {
  }

  @HostListener('window:keyup', ['$event'])
  keyEvent(event: KeyboardEvent) {
    if (event.keyCode === KEY_CODE.ENTER_KEY && this.emailFormControl.valid) {
      this.sendMail();
    }
  }

  ngOnInit() {
    this.route.data.subscribe(data => {
      this.site = data.site ? data.site : '';
    });
  }

  ngOnDestroy() {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
  }

  sendMail() {
    if (!this.emailFormControl.valid) {
      return;
    }
    this.loading = true;
    this.authenticationService.newPassword(this.emailFormControl.value, environment.urls.url)
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe({
        next: () => {
          // Réponse identique que le compte existe ou non (API-R69) : le
          // message ne doit pas révéler l'existence d'un compte.
          this.router.navigate(['login']);
          this.materialService.openSnackBar('Si un compte correspond à cet email, un lien pour réinitialiser votre mot de passe vous a été envoyé', 'green');
          this.loading = false;
        },
        error: (error) => {
          if (error?.status === 429) {
            this.materialService.openSnackBar('Trop de demandes. Réessayez plus tard.', 'red');
          } else {
            this.materialService.openSnackBar('Une erreur est survenue', 'red');
          }
          this.loading = false;
        },
      });
  }
}
